/**
 * Converte objeto em uma string com as classes
 *
 * @param classes Objeto com chaves como classes e valores como condições para aplicarem essas classes.
 *
 * @category DOM
 *
 * @example
 * ```ts
 * import { generateClasses } from '@ids/tools';
 *
 * const position = 'bottom';
 * const align = 'end';
 * const type = 'click';
 * const className = 'custom-css-class';
 *
 * generateClasses({
 *   'tooltip': true,
 *   'tooltip--right': position === 'right',
 *   'tooltip--bottom': position === 'bottom',
 *   'tooltip--left': position === 'left',
 *   'tooltip--start': align === 'start',
 *   'tooltip--end': align === 'end',
 *   'tooltip--info': type === 'hover',
 *   [className]: className,
 * });
 * // resultado possível: 'tooltip tooltip--bottom tooltip--end custom-css-class'
 * ```
 */
export const generateClasses = (classes) => Object.entries(classes)
    .reduce((string, [key, condition]) => (condition ? string + ' ' + key : string), '')
    .replace(/\s\s/g, ' ')
    .trim();
